export default class ApiError {

  code = null;
  text = '';
  body = null;
  retryAfter = 0;

  constructor({ status = 0, statusText = '', body = {} } = {}, retryAfter = 0) {
    this.code = status;
    this.text = statusText;
    this.body = body;
    this.retryAfter = retryAfter;
  }

}



// WEBPACK FOOTER //
// ./src/shared/errors/ApiError.js